export default "__VITE_ASSET__BnNR_lfq__"